<template>
  <v-alert color="grey darken-1" dark dense>
    <v-card-actions>
      Are you sure you want to delete?
      <v-spacer></v-spacer>
      <v-btn color="" outlined @click="onConfirm">Confirm delete</v-btn>
    </v-card-actions>
  </v-alert>
</template>

<script>
export default {
  name: "ConfirmDeleteInModal",
  props: {},
  data: () => ({}),
  computed: {},
  created() {},
  methods: {
    onConfirm() {
      this.$emit("confirmed");
    }
  }
};
</script>
<style scoped lang="stylus"></style>
